'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useAsUpgradePoint"];
import tinymce from 'tinymce';
import { __HS_PERSONALIZE } from '../constants/plugins';
import { initProperties } from '../utils/properties';
import { addControls } from './controls';
import { addTransforms, pluginSettingsToProps, handlePropertiesLoaded } from './shared';
export const HS_PERSONALIZE = __HS_PERSONALIZE;
function plugin(editor) {
  const _pluginSettingsToProp = pluginSettingsToProps(editor, HS_PERSONALIZE),
    {
      useAsUpgradePoint
    } = _pluginSettingsToProp,
    personalizeConfigProps = _objectWithoutPropertiesLoose(_pluginSettingsToProp, _excluded);
  addControls(editor, HS_PERSONALIZE, personalizeConfigProps, useAsUpgradePoint);
  if (useAsUpgradePoint) {
    // Don't render the transforms or init properties if it's only an upgrade point
    return;
  }
  addTransforms(editor, HS_PERSONALIZE);
  tinymce.canvas.addIdleCallback(editor, '[data-mce-property-category]', () => initProperties(editor, personalizeConfigProps).then(labelsMap => {
    handlePropertiesLoaded(editor, () => labelsMap);
  }));
}
tinymce.PluginManager.add(HS_PERSONALIZE, plugin);